import { call, put } from "@redux-saga/core/effects";
import { toast } from "react-toastify";
import { setGroups } from "../../reducers/keyStoreReducer";
import confirmSaga from "./modalSagas";
import { handleError } from "../../../util/errorHandler";
import { IdentityRestControllerApi } from "../../../generated/api/apis/IdentityRestControllerApi";
import { requestDownloadIdentityCa } from "../requests/keyGroupRequest";
import { getAPIConfig } from "../../../util/api-config";
import store from "../../configureStore";
import i18n from "../../../i18n/i18n";

function setUpClient() {
  return new IdentityRestControllerApi(
    getAPIConfig(store.getState().settings.internalSettings)
  );
}

export function* handleGetGroups(): any {
  try {
    const identityClient = setUpClient();
    const response = yield identityClient.listGroups();
    yield put(setGroups(response));
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleAddIdentity(action: any): any {
  try {
    const params = action.params;
    const identityClient = setUpClient();
    yield identityClient.addIdentity(
      params.group,
      params.type,
      params.storePwd,
      params.keyPwd,
      params.file
    );
    yield put({ type: "GET_GROUPS" });
    toast.success(String(i18n.t("toasts.identityAdded")));
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleChangeIdentity(action: any): any {
  try {
    const params = action.params;
    const identityClient = setUpClient();
    yield identityClient.changeActiveIdentity(params.group, params.thumbPrint);
    yield put({ type: "GET_GROUPS" });
    toast.success(String(i18n.t("toasts.identityUpdated")));
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleDeleteGroup(action: any): any {
  try {
    const params = action.params;
    const identityClient = setUpClient();
    yield identityClient.deleteGroup(params.group, params.thumbPrint);
    yield put({ type: "GET_GROUPS" });
    toast.success(String(i18n.t("toasts.groupDeleted")));
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleDeleteIdentityCa(action: any): any {
  try {
    const params = action.params;
    const identityClient = setUpClient();
    yield identityClient.deleteIdentity(params.group, params.thumbPrint);
    yield put({ type: "GET_GROUPS" });
    toast.success(String(i18n.t("toasts.identityDeleted")));
  } catch (error: any) {
    console.log(error);
    yield handleError(error);
  }
}

export function* handleDeleteIdentityModal(action: any): any {
  try {
    const isConfirmed = yield call(confirmSaga, "delete");
    if (isConfirmed) {
      yield call(handleDeleteIdentityCa, action);
    }
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleDeleteGroupModal(action: any): any {
  try {
    const isConfirmed = yield call(confirmSaga, "delete");
    if (isConfirmed) {
      yield call(handleDeleteGroup, action);
    }
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleDownloadIdentityCa(action: any): any {
  try {
    const FileSaver = require("file-saver");
    const response = yield call(requestDownloadIdentityCa, action.params);
    const [, fileName] =
      response.headers["content-disposition"].split("filename=");
    FileSaver.saveAs(new Blob([response.data]), fileName);
  } catch (error: any) {
    yield handleError(error);
  }
}
